<template>
  <div class="wizard-header">
    <div v-if="userEmail" class="account-bar account-bar-mobile">
      <span>{{ userEmail }}</span>
      <button type="button" class="logout-btn" @click="$emit('logout')">Cerrar sesión</button>
    </div>
    <div class="wizard-header-inner">
      <img src="../assets/logoK9corp.png" alt="Corporación K-9" class="wizard-logo" />
      <div>
        <div class="wizard-title">Solicitud de Empleo</div>
        <div v-if="!hideSubtitle" class="wizard-subtitle">
          Complete los 4 pasos · sus datos se guardan a medida que avanza entre los pasos
        </div>
      </div>
      <div v-if="userEmail" class="account-bar account-bar-desktop">
        <span>{{ userEmail }}</span>
        <button type="button" class="logout-btn" @click="$emit('logout')">Cerrar sesión</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteHeader",
  props: {
    // The "complete the 4 steps" line only makes sense once inside the
    // wizard — AuthGate hides it on login/register/recover.
    hideSubtitle: { type: Boolean, default: false },
    // Only passed once authenticated (NewApplicationForm) — AuthGate omits
    // it, which keeps the account bar out of the login/register screens.
    userEmail: { type: String, default: "" },
  },
};
</script>

<style scoped>
.wizard-header {
  width: 100%;
  background: #16223d;
}
.wizard-header-inner {
  max-width: 1250px;
  min-height: 150px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 64px);
  display: flex;
  align-items: center;
  gap: 18px;
  box-sizing: border-box;
}
.wizard-logo {
  height: 52px;
  width: auto;
  display: block;
}
.wizard-title {
  font: 700 20px "IBM Plex Serif", serif;
  color: #fff;
}
.wizard-subtitle {
  font: 400 12.5px "IBM Plex Sans", sans-serif;
  color: #aeb6c7;
  margin-top: 3px;
}
.account-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #fff;
  font: 13px "IBM Plex Sans", sans-serif;
}
.account-bar-desktop {
  margin-left: auto;
}
.account-bar-mobile {
  display: none;
}
.logout-btn {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 7px;
  color: #fff;
  padding: 5px 12px;
  font: 600 12px "IBM Plex Sans", sans-serif;
  cursor: pointer;
}

@media (max-width: 525px) {
  .wizard-header-inner {
    padding: 0 20px;
    min-height: 120px;
  }
  .account-bar-desktop {
    display: none;
  }
  .account-bar-mobile {
    display: flex;
    justify-content: flex-end;
    padding: 10px 24px;
  }
}
</style>
